import { render, staticRenderFns } from "./DigitalSignaturesTable.vue?vue&type=template&id=b159aca4&scoped=true&"
import script from "./DigitalSignaturesTable.vue?vue&type=script&lang=ts&"
export * from "./DigitalSignaturesTable.vue?vue&type=script&lang=ts&"
import style0 from "./DigitalSignaturesTable.vue?vue&type=style&index=0&id=b159aca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b159aca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSimpleTable,VTooltip})
